"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    marginBottom: {
      marginBottom: 20
    },
    formLabel: {
      fontSize: 12,
      marginTop: 3
    },
    colorPicker: {
      width: "100%",
      marginTop: ".2rem",
      marginBottom: "1rem"
    }
  };
});

var AttributesInput = function AttributesInput(_ref) {
  var objectsForm = _ref.objectsForm,
      properties = _ref.properties,
      handleItemAttribute = _ref.handleItemAttribute,
      handlePropertyChange = _ref.handlePropertyChange,
      accordionFilter = _ref.accordionFilter;
  var classes = useStyles();

  var _useState = (0, _react.useState)("text"),
      _useState2 = _slicedToArray(_useState, 2),
      inputType = _useState2[0],
      setInputType = _useState2[1];

  var attributes = properties.attributes;
  var optionsType = [{
    key: "text",
    text: "text",
    value: "text"
  }, {
    key: "number",
    text: "number",
    value: "number"
  }, {
    key: "tel",
    text: "phone",
    value: "tel"
  }];
  (0, _react.useEffect)(function () {
    return setInputType(attributes.type);
  }, [attributes.type]);

  var handleSelectAccordion = function handleSelectAccordion(e) {
    return handlePropertyChange(properties, "childAccordion", e.target.value);
  };

  return /*#__PURE__*/React.createElement("form", {
    style: {
      marginBottom: "1rem"
    }
  }, accordionFilter(objectsForm).length > 0 && /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Define a que acordeon pertenece",
    "aria-label": "value",
    placement: "top"
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(_core.FormLabel, {
    component: "label",
    className: classes.formLabel
  }, "Definir a que acordeon pertenece"), /*#__PURE__*/React.createElement(_core.RadioGroup, {
    "aria-label": "childAccordion",
    name: "childAccordion",
    value: properties.childAccordion,
    onChange: handleSelectAccordion
  }, accordionFilter(objectsForm).filter(function (res) {
    return res.i !== "step-0";
  }).map(function (acc, key) {
    return /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      key: key,
      value: acc.i,
      control: /*#__PURE__*/React.createElement(_core.Radio, {
        color: "primary"
      }),
      label: acc.label
    });
  })), /*#__PURE__*/React.createElement(_core.Button, {
    disabled: !properties.childAccordion,
    size: "small",
    onClick: function onClick(e) {
      e.preventDefault();
      handlePropertyChange(properties, "childAccordion", null);
    }
  }, "Reset accordion")))), /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Etiqueta".concat(!properties.validations.allowNull ? " *" : ""),
    value: attributes.label,
    onChange: function onChange(e) {
      handleItemAttribute(properties, "label", e.target.value);
    },
    className: classes.marginBottom
  }), /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Placeholder",
    value: attributes.placeholder,
    onChange: function onChange(e) {
      handleItemAttribute(properties, "placeholder", e.target.value);
    },
    className: classes.marginBottom
  }), /*#__PURE__*/React.createElement(_core.FormControl, null, /*#__PURE__*/React.createElement(_core.InputLabel, null, "Tipo"), /*#__PURE__*/React.createElement(_core.Select, {
    value: inputType,
    className: classes.marginBottom,
    onChange: function onChange(e) {
      var val = e.target.value;
      setInputType(val);
      handleItemAttribute(properties, "type", val);
    }
  }, optionsType.map(function (t, i) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      key: i,
      value: t.value
    }, t.text);
  }))), inputType === "text" ? /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "M\xE1ximo de caracteres",
    value: attributes.maxLength || "",
    onChange: function onChange(e) {
      handleItemAttribute(properties, "maxLength", e.target.value);
    },
    className: classes.marginBottom
  }) : inputType === "number" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Valor M\xEDnimo",
    value: attributes.min || "",
    onChange: function onChange(e) {
      handleItemAttribute(properties, "min", e.target.value);
    },
    className: classes.marginBottom
  }), /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Valor M\xE1ximo",
    value: attributes.max || "",
    onChange: function onChange(e) {
      handleItemAttribute(properties, "max", e.target.value);
    },
    className: classes.marginBottom
  })), /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "required",
      color: "primary",
      checked: attributes.isReadOnly,
      onChange: function onChange(e, checked) {
        handleItemAttribute(properties, "isReadOnly", checked);
      }
    }),
    label: "Solo lectura"
  }));
};

var _default = AttributesInput;
exports.default = _default;